(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.document_center_tabs = {
    attach: function (context, settings) {
      $('.document-menu ul li').click(function(){
        var tab_id = $(this).attr('data-tab');

        $('.document-menu ul li').removeClass('current');
        $('.document-content ul li').removeClass('current');

        $(this).addClass('current');
        $(".document-content ul li#"+tab_id).addClass('current');
      })
    }
  };

  Drupal.behaviors.documentCenterMobile = {
    attach: function (context, settings) {
      $('.document-center_mobile-menu-title').text($(".document-menu ul li.current .tab-title span").html());

      //toggle
      $(once('slidetoggle', '.document-center_mobile-menu-title')).click(function(e) {
          $('.document-menu-list').slideToggle(300); // 300 = fast
          $(this).toggleClass('open');
      });

      $('.document-menu-list .document-menu-item').click(function() {
        if($(window).width() < 960) { // @todo: redo for new breakpoints

          $('.document-menu-list').slideUp(300); // 300 = fast
          $('.document-center_mobile-menu-title').text($(this).find('.tab-title span').html());
          $('.document-center_mobile-menu-title').removeClass('open');
        }
      });
    }
  };

})(jQuery, Drupal, this, this.document);
